import cn from 'classnames';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import MinimumBasketValueNotice from 'components/minimum-basket-value-notice';
import { useCart } from 'contexts/cart';
import useMOVConditions from 'hooks/common/use-mov-conditions';
import { CheckoutCart } from 'modules/checkout/components/cart';
import { CheckoutCoupon } from 'modules/checkout/components/coupon';
import { useSubscriptionFunnel } from 'modules/subscription-funnel/state';
import { m } from 'motion/react';
import React from 'react';
import CustomerServiceInfo from '../../../components/customer-service-info';

interface Props {
  showCouponForm?: boolean;
  showCustomerServiceInfo?: boolean;
  isCartExpanded: boolean;
  className?: string;
  canRemoveProducts?: boolean;
  showMinumumBasketNotice?: boolean;
  hasExistingSubscription?: boolean;
  additionalClass?: string;
}

const FunnelCartBox: React.FC<Props> = ({
  isCartExpanded,
  showCouponForm = false,
  className,
  showCustomerServiceInfo = false,
  canRemoveProducts = false,
  showMinumumBasketNotice = true,
  hasExistingSubscription = false,
  additionalClass,
}) => {
  const { effectiveCart } = useCart();
  const { isExistingSubscription } = useSubscriptionFunnel();
  const { insufficientMoney, shouldShowMinimumBasketNotice } = useMOVConditions({
    effectiveCart,
    isInCheckout: true,
  });

  return (
    <LazyMotionWrapper>
      <m.div
        className={cn(
          'bg-other-white fixed top-0 left-0 h-screen max-h-full w-full overflow-auto rounded-md px-4 pt-28 lg:relative lg:h-auto lg:w-auto lg:max-w-md lg:transform-none! lg:overflow-visible lg:bg-transparent lg:px-6 lg:pt-0',
          additionalClass
        )}
        initial={{ y: '-100vh' }}
        animate={{
          y: isCartExpanded ? 0 : '-100vh',
        }}
        transition={{
          duration: 0.8,
          ease: [0.04, 0.62, 0.23, 0.98],
        }}
      >
        {showCouponForm && (
          <div className="-mx-4 lg:mx-0 lg:hidden">
            <CheckoutCoupon />
          </div>
        )}
        <div className={className}>
          <CheckoutCart
            canRemoveProducts={canRemoveProducts}
            hasExistingSubscription={hasExistingSubscription}
            additionalComponent={
              showMinumumBasketNotice && (
                <>
                  {shouldShowMinimumBasketNotice && !isExistingSubscription && (
                    <div className="mx-4 mt-1 py-4 text-sm">
                      <MinimumBasketValueNotice insufficientMoney={insufficientMoney} />
                    </div>
                  )}
                </>
              )
            }
          />
        </div>
        {showCouponForm && (
          <div className="hidden lg:mt-4 lg:block">
            <CheckoutCoupon />
          </div>
        )}
        {/* Show customer info card component on desktop */}
        {showCustomerServiceInfo && <CustomerServiceInfo showDesktop />}
      </m.div>
    </LazyMotionWrapper>
  );
};

export default FunnelCartBox;
